export default __webpack_public_path__ + "static/media/BlackSherrif.eb8f6314.jpg";